(function () {
  var container = document.querySelector('.kos-free-content-element-container');
  if (!container) return;

  var kosData = JSON.parse(container.getAttribute('data-kos-webinars'));
  var status = container.getAttribute('data-customer-status');
  var customerEmail = container.getAttribute('data-customer-email') || '';
  var customerFirstName = container.getAttribute('data-customer-firstname') || '';

  document.addEventListener('DOMContentLoaded', function () {
    var currentUrl = window.location.href;

    if (status === 'true' || currentUrl.includes('bauer') || currentUrl.includes('direct') || currentUrl.includes('meta')) {
      return showContent(container);
    } else {
      var returnUrl = '/pages/kos-detail?videoid=' + getVideoIdFromUrl();
      window.location.replace('/account/login?return_url=' + encodeURIComponent(returnUrl));
    }
  });

  function showContent(container) {
    var searchParam = getVideoIdFromUrl();

    if (searchParam) {
      var webinar = getWebinar(kosData, searchParam);

      if (webinar.length !== 0) {
        createKosTiles(webinar);
      } else {
        showError(container, 400, '<div class="error-wrapper"><div class="error-headline">Aufzeichnung nicht gefunden</div><div class="error-text">Bitte gehe zur <a href="https://education.omr.com/pages/kos-uebersicht">Übersichtsseite</a>  und wähle von dort dein Video aus.</div></div>');
      }
    } else {
      showError(container, 400, '<div class="error-wrapper"><div class="error-headline">Aufzeichnung nicht gefunden</div><div class="error-text">Bitte gehe zur <a href="https://education.omr.com/pages/kos-uebersicht">Übersichtsseite</a>  und wähle von dort dein Video aus.</div></div>');
    }
  }

  function getWebinar(array, searchParam) {
    var result = [];
    array.forEach(function (item) {
      if (item.kod_id == searchParam) {
        result.push(item);
      }
    });
    return result;
  }

  function getVideoIdFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('videoid');
  }
  function buildBackUrl() {
    var params = new URLSearchParams(window.location.search);
    params.delete('videoid');
    var qs = params.toString();
    return 'https://education.omr.com/pages/kostenlose-online-seminare-aufzeichnungen' + (qs ? '?' + qs : '');
  }
  function showError(element, height, message) {
    element.innerHTML = '';
    element.style.height = height + 'px';
    element.innerHTML = message;
  }

  function createBadge(text) {
    var wrapper = document.createElement('div');
    wrapper.className = 'ui-badge';
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.gap = '6px';
    wrapper.style.padding = '2px 10px';
    wrapper.style.backgroundColor = '#ebe8ff';
    wrapper.style.borderRadius = '999px';
    wrapper.style.border = '1px solid rgba(115, 55, 252, 0.2)';
  
    var p = document.createElement('p');
    p.className = 'ui-badge__text';
    p.textContent = text;
    p.style.fontSize = 'var(--fluid-size-label-m)';
    p.style.fontWeight = '600';
    p.style.lineHeight = '140%';
    p.style.letterSpacing = '0.28px';
    p.style.color = '#601ee3';
  
    wrapper.appendChild(p);
    return wrapper;
  }
  function createKosTiles(array) {
    var videoContainerEl = document.querySelector('.kos-free-content-element-container');
    array.forEach(function (item, index) {
      var headLine = item.headline;
      var subheadLine = item.subheadline ?? "";
      var introText = item.text.replace('<b>Um auf das Video und die Slides zuzugreifen, kurz auf das Video klicken, anmelden und losschauen.</b>', '');
      var slidesLink = item.slideslink;
      var webinarName = item.webinarname;
      var listParameter = item.listparameter;

      var videoEl = createAndReturnKosPageElements('div', 'kos-free-video-element', 'kos-free-video-element-' + index, index, '');
      videoEl.setAttribute('data-slideslink', slidesLink);
      videoEl.setAttribute('data-webinarname', webinarName);
      videoEl.setAttribute('data-listparameter', listParameter);

      var backEl = createAndReturnKosPageElements('div', 'kos-free-content-back-wrapper', 'kos-free-content-back-wrapper-' + index, '', '');
      var backUrl = buildBackUrl();
      backEl.innerHTML =
        '<p>' +
          '<a href="' + backUrl + '" style="font-family: var(--main-font);">\u2190 Zur\u00fcck zur \u00dcbersicht</a>' +
        '</p>';

      var headlineEl = createAndReturnKosPageElements('div', 'kos-free-content-headline', 'kos-free-content-headline-' + index, index, headLine, 'responsive-h1');
      var subheadlineEl = createAndReturnKosPageElements('div', 'kos-free-content-subheadline', 'kos-free-content-subheadline-' + index, index, subheadLine, 'responsive-text1');
      var badgeEl = createBadge('Mit Aufzeichnung');
      var textEl = createAndReturnKosPageElements('div', 'kos-free-content-intro-text', 'kos-free-content-intro-text-' + index, index, '', 'responsive-text1');
      textEl.innerHTML = introText;

      var slidesEl = createSlidesButton(item);

      var imageContainerEl = createAndReturnKosPageElements('div', 'kos-free-content-state-container', 'kos-free-content-state-container-' + index, index, '');
      var imageEl = createAndReturnKosPageElements('img', 'youtube-player-image', 'youtube-player-image-' + index, index, '');
      imageEl.src = item.thumbimage;
      imageContainerEl.appendChild(imageEl);

      videoEl.appendChild(backEl);
      videoEl.appendChild(badgeEl);
      videoEl.appendChild(headlineEl);
      videoEl.appendChild(subheadlineEl);
      videoEl.appendChild(textEl);
      videoEl.appendChild(slidesEl);
      videoEl.appendChild(imageContainerEl);

      videoContainerEl.appendChild(videoEl);
      addEventListenersKosImageElements(imageEl, index, item);
    });
  }

  function removeImage(containerEl) {
    containerEl.innerHTML = '';
  }

  function showVideo(containerEl, item) {
    var videoId = item.kod_id;
    containerEl.innerHTML =
      '<iframe width="640" height="360" src="https://www.youtube.com/embed/' + videoId + '" frameborder="0" allowfullscreen></iframe>';
  }

  function addEventListenersKosImageElements(element, id, item) {
    element.addEventListener('click', function () {
      var containerEl = document.querySelector('.kos-free-content-state-container');
      removeImage(containerEl);
      showVideo(containerEl, item);
      sendKosDataToWebhook(customerEmail, item);
    });
  }

  function createAndReturnKosPageElements(type, classname, id, index, innertext, additionalOptionalClassName) {
    var element = document.createElement(type);
    element.classList.add(classname);
    element.setAttribute('id', id);
    element.innerText = innertext;

    if (additionalOptionalClassName) {
      element.classList.add(additionalOptionalClassName);
    }

    return element;
  }

  function createSlidesButton(item) {
    var slidesLink = item.slideslink;
    var downloadName = slidesLink;

    var wrapperEl = createAndReturnKosPageElements('div', 'kos-free-slides-download-wrapper', 'kos-free-slides-download-wrapper', '', '');
    wrapperEl.innerHTML =
      '<a href="' + slidesLink + '" download="' + downloadName + '" target="_blank">' +
        '<div class="kos-free-slides-download-button omr-button-primary-large omr-button-primary--purple" id="kos-free-slides-download-button">Slides Herunterladen</div>' +
      '</a>';

    return wrapperEl;
  }

  function sendKosDataToWebhook(email, object) {
    var firstName = '&firstname=' + customerFirstName;
    var doiMessage = '&doiMessage=Die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Solltest du noch kein Newsletter-Subscriber sein, best\u00e4tige bitte die Mail, die wir dir gerade geschickt haben.';
    var url = window.location.href;
    var data = 'url=' + url + '&email=' + email + '&kosname=' + object.webinarname + '&utm_content=kos_oD' + firstName + doiMessage;

    fetch(
      'https://hooks.zapier.com/hooks/catch/590116/3adjhx4/?' + data,
      { method: 'get', mode: 'cors' }
    )
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status === 'success') {
          console.log('fetch executed');
        }
      });
  }
})();
